import React, { Suspense, useState } from 'react';
import LazyLoad, { lazyload } from 'react-lazyload';
import { Lottie } from '@crello/react-lottie';

import Head from 'next/head';

import st from './index.module.scss';

import Pricing from '../../../components/video-production/Pricing';
import BradCrumbs from '../../../components/Base/BradCrumbs';
import Engagement from '../../../components/Engagement';
import Faq from '../../../components/Faq';
import ProcessSliderMotionGraphics from '../../../components/sliders/ProcessSliderMotionGraphics';
import typesLottie from '../../../public/images/types.json';
import Why from '../../../components/Why';
import ViewMore from '../../../components/ViewMore';
import BenefitsMotionGraphics from '../../../components/video-production/explainer-videos/BenefitsMotionGraphics';
import SolveProblemsMotionGraphics from '../../../components/video-production/explainer-videos/SolveProblemsMotionGraphics';

lazyload({
  width: '100%',
});

const ExplainerVideosMotionGraphics = props => {
  const [showPricingModalF, setShowPricingModalF] = useState(false);
  const [videoLength, setVideoLength] = useState([]);
  const [script, setScript] = useState([]);

  const showPricingModal = () => {
    if (props.width < 768) {
      window.location.href = '/video-production/get-pricing';
    } else {
      setShowPricingModalF(true);
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      window.location.hash = 'open';
    }
  };
  const hidePricingModal = () => {
    setShowPricingModalF(false);
    document.body.style.overflow = 'auto';
    document.body.style.overflowX = 'hidden';
    history.replaceState(null, null, ' ');
    document.documentElement.style.overflow = 'auto';
  };

  return (
    <>
      <Head>
        <title>Video Production - Motion Graphics Explainer Video | Prodigi</title>
        <link rel="alternate" hrefLang="en" href="https://weprodigi.com/video-production/motion-graphics-explainer-video" />
        <meta
          name="description"
          content="Inspire your audience with motion graphics explainer videos. Simple, clear, and visually appealing narrative for your brand's message."
        />
        <meta property="og:url" content="https://weprodigi.com/video-production/motion-graphics-explainer-video" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Video Production - Motion Graphics Explainer Video | Prodigi" />
        <meta
          property="og:description"
          content="Inspire your audience with motion graphics explainer videos. Simple, clear, and visually appealing narrative for your brand's message."
        />
        <meta property="og:image" content="https://weprodigi.com/uploads/images/explainer-videos/motion-graphics-explainer/og.jpg" />
        <script
          type="application/ld+json"
          className="organization-schema"
          dangerouslySetInnerHTML={{
            __html: `{
              "@context": "http://schema.org",
              "@type": "WebPage",
              "name": "Video Production - Motion Graphics Explainer Video | Prodigi",
              "description": "Inspire your audience with motion graphics explainer videos. Simple, clear, and visually appealing narrative for your brand's message.",
              "url": "https://weprodigi.com/video-production/motion-graphics-explainer-video",
              "breadcrumb": {
                "@type": "BreadcrumbList",
                "itemListElement": [
                  {
                    "@type": "ListItem",
                    "position": 1,
                    "name": "Home",
                    "item": "https://weprodigi.com"
                  },
                  {
                    "@type": "ListItem",
                    "position": 2,
                    "name": "Full Service Video Production",
                    "item": "https://weprodigi.com/video-production"
                  },
                  {
                    "@type": "ListItem",
                    "position": 3,
                    "name": "Motion Graphics Explainer Video Production",
                    "item": "https://weprodigi.com/video-production/motion-graphics-explainer-video"
                  }
                ]
              },
              "mainEntity": {
                "@type": "Product",
                "name": "Motion Graphics Explainer Video Production",
                "description": "Inspire your audience with motion graphics explainer videos. Simple, clear, and visually appealing narrative for your brand's message.",
                "brand": {
                  "@type": "Brand",
                  "name": "Weprodigi"
                },
                "offers": {
                  "@type": "Offer",
                  "price": "1200",
                  "priceCurrency": "USD",
                  "seller": {
                    "@type": "Organization",
                    "name": "Weprodigi"
                  }
                },
                "image": "https://weprodigi.com/images/logovertical.svg",
                "review": [
                  {
                    "@type": "Review",
                    "reviewRating": {
                      "@type": "Rating",
                      "ratingValue": "5",
                      "bestRating": "5",
                      "worstRating": "1"
                    },
                    "author": {
                      "@type": "Person",
                      "name": "Ann Walker"
                    },
                    "datePublished": "2023-12-18",
                    "reviewBody": "The motion graphics were not only visually stunning but also effectively conveyed our message. I highly recommend Prodigy for anyone in need of top-notch motion graphics services!"
                  },
                  {
                    "@type": "Review",
                    "reviewRating": {
                      "@type": "Rating",
                      "ratingValue": "5",
                      "bestRating": "5",
                      "worstRating": "1"
                    },
                    "author": {
                      "@type": "Person",
                      "name": "Amelie Hughes"
                    },
                    "datePublished": "2023-12- 4",
                    "reviewBody": "As a marketing manager, I've had the opportunity to collaborate with various agencies for motion graphics projects, but none have come close to the level of excellence demonstrated by Prodigy.If you're looking for a partner who can elevate your brand through exceptional motion graphics, look no further than Prodigy!"
                  },
                  {
                    "@type": "Review",
                    "reviewRating": {
                      "@type": "Rating",
                      "ratingValue": "4.9",
                      "bestRating": "5",
                      "worstRating": "1"
                    },
                    "author": {
                      "@type": "Person",
                      "name": "Melanie Parker"
                    },
                    "datePublished": "2024-03-2",
                    "reviewBody": " I had the pleasure of working with Prodigy for our company's explainer video, and I must say, they exceeded all expectations! Our video turned out even better than we had envisioned, thanks to Prodigy's creativity and expertise."
                  }
                ],
                "aggregateRating": {
                  "@type": "AggregateRating",
                  "ratingValue": "4.9",
                  "reviewCount": "3"
                }
              }
            }            
            `,
          }}
        />
      </Head>

      {/*    Header video */}
      <div className={`relative w-full  h-intro  overflow-hidden  `}>
        <video
          width="100%"
          height="100%"
          autoPlay
          loop
          muted
          playsInline
          preload="none"
          id="header-11"
          className={'absolute h-intro md:h-full ' + st['header-mp4']}
        >
          <source
            src="https://weprodigi.com/uploads/images/explainer-videos/motion-graphics-explainer/motion-graphics-explainer.mp4"
            type="video/mp4"
          />
        </video>
        <div className={st['overlay']}></div>
        <div className="container h-full">
          <div className="relative h-full  flex flex-col flex-wrap justify-center items-start overflow-hidden">
            <h1 className="max-w-300 md:max-w-600 uppercase md:normal-case text-white text-30 md:text-72 font-black md:font-bold leading-tight">
              Motion Graphics Explainer Video Production
            </h1>
            <a
              onClick={showPricingModal}
              className="relative flex items-center justify-center min-w-250 z-10 border-2 rounded-5 border-green-badge hover:border-green-hover text-18 text-white px-23 mt-48 md:mt-23 py-8 bg-green-badge hover:bg-green-hover hover:text-white transition-all   transition-400 cursor-pointer"
            >
              Get Pricing
              <img src="https://weprodigi.com/uploads/images/explainer-videos/buttonIcon.svg" className={'ml-10'} alt="pricing icon" />
            </a>
          </div>
        </div>
      </div>

      <div className="bg-white">
        <div className="container">
          <BradCrumbs
            items={[
              {
                url: '/video-production',
                name: 'Video Production',
              },
              {
                url: '/video-production/explainer-videos',
                name: 'Explainer Video Production',
              },
              {
                url: '/video-production/motion-graphics-explainer-video',
                name: 'Motion Graphics Explainer Video',
              },
            ]}
          />
          <div className="relative pt-20 md:pt-0 pb-48">
            <div className="flex flex-wrap md:flex-nowrap justify-between">
              <LazyLoad className="mr-auto mt-24 md:mt-0 max-w-270 w-full md:w-auto" height={200} once>
                <Lottie
                  config={{
                    animationData: typesLottie,
                    loop: true,
                    autoPlay: true,
                  }}
                  playingState="playing"
                />
              </LazyLoad>
              <div className="flex flex-col ml-12 items-center justify-center max-w-756">
                <Engagement title="Video">
                  A motion graphics explainer video is a unique mix of motion graphics and bright colors that brings your bold ideas to life. How?
                  Discover just a scroll away!
                </Engagement>
              </div>
            </div>
          </div>
        </div>
      </div>

      <LazyLoad height={200} once>
        <div className={'bg-gray-white py-24'}>
          <div className="container">
            <h2 className={'w-full md:w-half-auto font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              What is Motion Graphics Explainer Video?
            </h2>

            <div className={'block md:flex justify-between flex-row md:flex-row-reverse'}>
              <div className=" pl-0 md:pl-20 pb-10 w-full md:w-half-auto block  mt-23 mb-10">
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/FDl_Bbzxu1g?controls=0"
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>
                  AtkinsRealis | Engineering Motion Graphics Animation
                </p>
              </div>

              <p className={'mt-20 w-half-auto hidden md:block'}>
                A motion graphics explainer video combines text and eye-catching graphics. Imagine colorful animated illustrations that pop up on the
                screen, creating the illusion of 2D vibrant movement. But it’s not just a movement! It’s an engaging visual storyline that weaves
                around your ideas, product, or service. Unlike other styles of animation, the focus here isn’t on the characters, but on the lively
                alternation of shapes and colors. Elements move, spread, and morph in front of the viewer. This makes any information light and
                memorable. With a motion graphics explainer video, your message isn’t only seen but felt.
              </p>
              <div className={'mt-20 block md:hidden'}>
                <ViewMore ln={40}>
                  A motion graphics explainer video combines text and eye-catching graphics. Imagine colorful animated illustrations that pop up on
                  the screen, creating the illusion of 2D vibrant movement. But it’s not just a movement! It’s an engaging visual storyline that
                  weaves around your ideas, product, or service. Unlike other styles of animation, the focus here isn’t on the characters, but on the
                  lively alternation of shapes and colors. Elements move, spread, and morph in front of the viewer. This makes any information light
                  and memorable. With a motion graphics explainer video, your message isn’t only seen but felt.
                </ViewMore>
              </div>
            </div>
            <br className={'clear-both hidden'} />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className={'bg-white py-24'}>
          <div className="container">
            <h2 className={'w-full md:w-75p font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              Where to Use Motion Graphics Explainer Videos?
            </h2>
            <p className={'mt-20'}>
              90% of all our mental stimulation comes from visual and audio aids. This is where the secret to the power of explainer videos lies. And
              where are these factors more compelling and lively than in motion graphics explainer videos? In many industries, they are like widely
              opened doors to real success.
            </p>

            <div className="flex flex-wrap-reverse md:flex-nowrap justify-between items-start mt-0 md:mt-24">
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/CXKUM60vo8o?controls=0"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>Createvolve | Software Solution Animation</p>
              </div>

              <div className={'w-full md:w-half-auto mt-24 md:mt-0'}>
                <h3 className="text-purple font-bold text-24   leading-none">Marketing and Advertising</h3>
                <div className={'mt-16 hidden md:block'}>
                  Do you want to level up your marketing and advertising efforts? Motion graphics on video can be your first solution. Create animated
                  marketing videos with this style and use them in social media ads, landing pages, e-commerce platforms, email marketing, and
                  wherever else you want. The format allows complex ideas to be simplified in language the viewer can understand.How about its visual
                  appeal, tailored to your animated branding? It will not leave anyone indifferent.
                </div>
                <div className={'mt-16 block md:hidden'}>
                  <ViewMore ln={40}>
                    Do you want to level up your marketing and advertising efforts? Motion graphics on video can be your first solution. Create
                    animated marketing videos with this style and use them in social media ads, landing pages, e-commerce platforms, email marketing,
                    and wherever else you want. The format allows complex ideas to be simplified in language the viewer can understand.How about its
                    visual appeal, tailored to your animated branding? It will not leave anyone indifferent.
                  </ViewMore>
                </div>
              </div>
            </div>

            <div className="flex flex-wrap md:flex-nowrap justify-between mt-0 md:mt-48">
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <h3 className="text-purple font-bold text-24 leading-none">Education and Training</h3>
                <p className={'mt-16'}></p>

                <p className={'mt-16 hidden md:block'}>
                  In your view, what's the greatest challenge in today's education? Experts feel that it can seem difficult to engage students and
                  make concepts clear for them. In this trend, motion graphics explainer videos have come up as a great avenue for education. They can
                  cover the topic well, highlighting key points. Well-suited for online courses, e-learning materials, and training modules, motion
                  graphics also offer a significant improvement in traditional teaching methods.
                </p>
                <div className={'mt-16 block md:hidden'}>
                  <ViewMore ln={40}>
                    In your view, what's the greatest challenge in today's education? Experts feel that it can seem difficult to engage students and
                    make concepts clear for them. In this trend, motion graphics explainer videos have come up as a great avenue for education. They
                    can cover the topic well, highlighting key points. Well-suited for online courses, e-learning materials, and training modules,
                    motion graphics also offer a significant improvement in traditional teaching methods.
                  </ViewMore>
                </div>
              </div>
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/KxPiwOO-RpY?controls=0"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>AWN | Software Solution Animation</p>
              </div>
            </div>
            <div className="flex flex-wrap-reverse md:flex-nowrap justify-between mt-24 md:mt-48">
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/G-0qYKpM36s?controls=0"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>Innovation Process | Software Solution Animation</p>
              </div>

              <div className={'w-full md:w-half-auto '}>
                <h3 className="text-purple font-bold text-24 leading-none">Technology and Software</h3>
                <p className={'mt-16 hidden md:block'}>
                  Can you imagine anything growing faster than the technology and software industry? Probably not. How to keep up with this fast pace?
                  Our top answer is "with a motion graphics explainer video". It is used to demonstrate the features and benefits of a new technology
                  product or software. Help your audience demystify complex technology concepts, and understand how your product works or what its
                  value to them․
                </p>
                <div className={'mt-16 block md:hidden'}>
                  <ViewMore ln={'40'}>
                    Can you imagine anything growing faster than the technology and software industry? Probably not. How to keep up with this fast
                    pace? Our top answer is "with a motion graphics explainer video". It is used to demonstrate the features and benefits of a new
                    technology product or software. Help your audience demystify complex technology concepts, and understand how your product works or
                    what its value to them․
                  </ViewMore>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className={'bg-gray-light py-24'}>
          <div className="container">
            <h2 className={'w-full font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              Benefits of Motion Graphics Explainer Videos
            </h2>
            <p className={'mt-20'}>
              Imagine capturing every eye with lively graphics in movement. Now picture you can explain complex concepts in a fun way with cool
              animations and animated infographics. This is exactly what a motion graphics explainer video does for your message. Curious about its
              benefits? Scroll down to discover more!
            </p>
            <Suspense fallback={`Loading...`}>
              <BenefitsMotionGraphics />
            </Suspense>
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className="bg-white">
          <div className="container py-23">
            <h2 className="text-purple text-24 md:text-36 text-left mb-23 font-black uppercase leading-none">
              Our Motion Graphics Explainer Video Production Process
            </h2>
            <ProcessSliderMotionGraphics />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={0} once>
        <div className={'h-500 md:h-310 overflow-hidden relative ' + st['bg-contact']}>
          <div id="stars" />
          <div id="stars2" />
          <div id="stars3" />
          <div className="container flex flex-wrap md:flex-nowrap justify-between items-end md:items-center h-full ">
            <div
              className={
                'mt-24 md:mt-0 text-left md:text-center font-bold uppercase  text-white leading-28 md:leading-44  text-20 md:text-23 lg:text-36'
              }
            >
              CALCULATE YOUR MOTION GRAPHICS EXPLAINER VIDEO PRICE
              <br />
              <span className={'pt-20 font-normal normal-case text-18 md:text-20 leading-20 md:leading-29 '}>
                Answer five questions and get to know the price!
              </span>
              <div className={'flex justify-end md:justify-center mt-0 leading-0'}>
                <button
                  onClick={showPricingModal}
                  className="uppercase h-40 text-18 leading-24  hover:bg-green-hover md:flex justify-center items-center   w-auto mt-24 text-white bg-green rounded-5 px-23 py-0 md:py-5"
                >
                  Start Now
                </button>
              </div>
            </div>
            <img src="https://weprodigi.com/uploads/images/explainer-videos/Inga.webp" alt="eva" className={st['inga']} />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className={'bg-white py-24'}>
          <div className="container">
            <h2 className={'w-full font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              How Motion Graphics Explainer Video Can Help Your Business?
            </h2>
            <p className={'mt-20'}>
              Motion graphics video shines in business at its full potential. Here is how it sets the stage for business goals.
            </p>
            <Suspense fallback={`Loading...`}>
              <SolveProblemsMotionGraphics />
            </Suspense>
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className="bg-gray-light">
          <div className="container py-23">
            <h2 className="uppercase text-30 md:text-36 mb-23 font-black text-purple leading-none">
              Why Choose Us for Your Motion Graphics Explainer Video?
            </h2>
            <Why
              content={[
                {
                  title: 'We provide unmatched production',
                  answer:
                    'Throughout the animated content creation process, our experts use the latest tools for an impressive visual and auditory experience. ',
                },
                {
                  title: 'We craft one-of-a-kind solutions',
                  answer:
                    "You're always sure that with creative glow and a customized approach, your video stands out uniquely. That’s the main strength of our motion graphics video production services.",
                },
                {
                  title: 'We navigate you from A to Z',
                  answer:
                    'Our experienced professionals are at your disposal throughout the motion graphics video production process: from strategic planning to optimizing video for different platforms.',
                },
                {
                  title: 'We stand with you, wholeheartedly',
                  answer:
                    'Your long-term satisfaction is our greatest asset. So, in our motion graphics explainer video agency, your project management is always in reliable hands.',
                },
                {
                  title: 'We don’t require prepayment',
                  answer:
                    'We picked the milestone payment method for our motion graphics explainer video services, as we believe that it is the best option for both us and our clients.',
                },
              ]}
            />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className="bg-white">
          <div className="container py-23">
            <h2 className="uppercase text-24 md:text-36 mb-23 font-black text-purple leading-none">FAQ</h2>
            <div className="grid md:grid-cols-2 md:gap-30">
              <Faq
                content={[
                  {
                    title: 'Do I need a script for a motion graphic design video?',
                    answer:
                      'Yes, a unique script is the fundamental blueprint that makes the visual story of your video be realized. Moreover, the first practical step in motion graphics video production is creating a script.',
                  },
                  {
                    title: 'How long does it take to create a motion graphic design video?',
                    answer:
                      'A simple motion graphics video without complex characters and details can be created in 4 to 6 weeks, while more complex projects can take 3 to 6 months or even longer.',
                  },
                ]}
              />
              <Faq
                content={[
                  {
                    title: 'What software/tools are used in motion graphic design?',
                    answer:
                      'Most of this kind of design employs the use of software mostly, which includes Adobe After Effects for both 2D animation and visual effects, Adobe Illustrator for the making of vector graphics, and both Cinema 4D and Blender for creating the 3D models and animation.',
                  },
                  {
                    title: 'Are motion graphic design videos suitable for social media?',
                    answer: 'Absolutely! With visual appeal and power of dynamism, motion graphic videos are simply gold for social media.',
                  },
                ]}
              />
            </div>
          </div>
        </div>
      </LazyLoad>

      <Pricing videoLength={videoLength} script={script} country={props.country} show={showPricingModalF} hide={hidePricingModal} step={1} />
    </>
  );
};

export default ExplainerVideosMotionGraphics;
